import { useState, useEffect } from 'react';
import { useAuth } from '../firebase/AuthProvider'; 

export type SignalStrength = 'good' | 'medium' | 'poor' | 'unknown';

export const useNetworkQuality = () => {
  const { currentUser } = useAuth();
  const [signalStrength, setSignalStrength] = useState<SignalStrength>('unknown');
  const [latency, setLatency] = useState<number>(0);

  useEffect(() => {
    if (!currentUser) return;

    const checkNetwork = async () => {
      const networkCheckUrl = `${process.env.REACT_APP_API_BASE_URL}/video/turn`;

      try {
        const token = await currentUser.getIdToken();
        const startTime = Date.now();
        //commenting this code becouse of there is no endpoint in backend
        // await fetch(networkCheckUrl, {
        //   method: 'GET',
        //   headers: {
        //     'Authorization': `Bearer ${token}`,
        //   },
        //   cache: 'no-store', // Important: Ensures a fresh request every time
        // });

        const roundTripTime = Date.now() - startTime;
        setLatency(roundTripTime);

        // Determine signal strength based on latency
        if (roundTripTime < 300) {
          setSignalStrength('good');
        } else if (roundTripTime < 600) {
          setSignalStrength('medium');
        } else {
          setSignalStrength('poor');
        }
      } catch (err) {
        console.error("Network check failed:", err);
        setSignalStrength('poor');
        setLatency(-1); // Use -1 or another indicator for a failed test
      }
    };

    checkNetwork(); // Initial check
    const intervalId = setInterval(checkNetwork, 5000); // Check every 5 seconds

    // Cleanup function to stop the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [currentUser]);

  // Return the values for the component to use
  return { signalStrength, latency };
};